__turbopack_context__.v({
  "emptyStateBody": "nP-OrG_emptyStateBody",
  "emptyStateContainer": "nP-OrG_emptyStateContainer",
  "emptyStateTextContainer": "nP-OrG_emptyStateTextContainer",
  "productGrid": "nP-OrG_productGrid",
  "segment": "nP-OrG_segment",
  "segments": "nP-OrG_segments",
  "sixColumns": "nP-OrG_sixColumns",
});
